<div class="row">
  <div class="col-md-12">
    <button mat-flat-button color="primary" type="button" (click)="create()">Adicionar Item</button>
  </div>
  <hr />
  <div class="col-md-12">
    <table datatable [dtOptions]="dtOptions" *ngIf="dtOptions" class="table table-bordered table-striped table-hover"
      style="width: 100%;">
      <thead>
        <tr>
          <th class="text-center" width="80">Ordem</th>
          <th class="text-center" width="160">Tipo</th>
          <th class="text-center">Texto</th>
          <th class="text-center">URL</th>
          <th class="text-center" width="160">Telefone</th>
          <th class="text-center" width="150"></th>
        </tr>
      </thead>
      <tbody *ngIf="models?.length != 0">
        <tr *ngFor="let item of models">
          <td class="text-center">{{item.order}}</td>
          <td>{{typesService.getMetaMsgTemplateButtonTypeNome(item.tipo)}}</td>
          <td>{{item.text}}</td>
          <td>{{item.url}}</td>
          <td>{{item.phoneNumber}}</td>
          <td class="text-center">
            <button mat-icon-button type="button" (click)="edit(item)" matTooltip="Editar">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button type="button" (click)="delete(item.id)" matTooltip="Excluir">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <app-meta-msg-template-button-modal #modal (modalSave)="onResponse($event)" [metaMsgTemplateId]="metaMsgTemplateId">
  </app-meta-msg-template-button-modal>
</div>
